import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
const pickerClasses = [
  "cursor-pointer",
  "bg-calendar dark:bg-calendarDark",
  "bg-[right_10px_top_10px]",
  "bg-[length:18px_18px]",
  "bg-no-repeat",
  "flex",
  "flex-row-reverse",
  "border",
  "outline-none",
  "text-gray-900",
  "text-sm",
  "rounded-lg",
  "block",
  "w-full",
  "p-2",
  "dark:bg-gray-700",
  "dark:placeholder-gray-400",
  "dark:text-white",
  "dark:focus:ring-blue-500",
  "dark:focus:border-blue-500",
];


const yearDropdownPlugin = function (config = {}) {
  return function (fp) {
    const currentYear = new Date().getFullYear();
    const startYear = config.startYear || currentYear - 100;
    const endYear = config.endYear || currentYear;
    const yearSelect = document.createElement("select");
    yearSelect.className = "flatpickr-year-dropdown bg-black ml-2 text-gray-100 rounded-md px-2";

    for (let y = endYear; y >= startYear; y--) {
      const option = document.createElement("option");
      option.value = y;
      option.textContent = y;
      yearSelect.appendChild(option);
    }
    yearSelect.value = currentYear;
    yearSelect.addEventListener("change", (e) => {
      fp.changeYear(parseInt(e.target.value, 10));
    });

    return {
      onReady() {
        const yearInput = fp.calendarContainer.querySelector(".numInputWrapper");
        if (yearInput) yearInput.style.display = "none";
        const currentMonthElem = fp.calendarContainer.querySelector(".flatpickr-current-month");
        currentMonthElem.appendChild(yearSelect);
        const monthSelect = currentMonthElem.querySelector("select");
        if (monthSelect) {

          monthSelect.className = "flatpickr-month-dropdown bg-black ";

        }
      },
      onValueUpdate(selectedDates) {
        if (selectedDates.length > 0) {
          yearSelect.value = selectedDates[0].getFullYear();
        }
      },
      onMonthChange() {
        yearSelect.value = fp.currentYear;
      },
      onYearChange() {
        yearSelect.value = fp.currentYear;
      },
    };
  };
};


const ODateRangePicker = (props) => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const onChangeStartDate = ([date]) => {
    setStartDate(date);
    props?.handleDateChange(date, endDate);
  };
  const onChangeEndDate = ([date]) => {
    setEndDate(date);
    props.handleDateChange(startDate, date);
  };
  const handleReset = () => {
    setStartDate("");
    setEndDate("");
  };
  useEffect(() => {
    if (props?.place === "dashboard") {
      handleReset();
    } else {
      if (props?.isReset) {
        props?.setIsReset({
          ...props?.filterData,
          startDate: false,
          endDate: false,
        });
        handleReset();
      }
    }
  }, [props?.isReset]);

  useEffect(() => {
    setStartDate(props?.filterData?.startDate);
    setEndDate(props?.filterData?.endDate);
  }, [props?.filterData]);

  return (
    // <div className='sm:flex items-center text-center sm:text-left px-3 md:px-4 xl:px-7 lg:px-5  md:py-5 py-4 md:py-8 border'>
    <>
      <div className=" relative flex items-center mb-3">
        <label className="mx-2 text-[#B8BBBF] text-xs whitespace-nowrap">{t("O_FROM")}</label>
        <Flatpickr
          className={pickerClasses.join(" ")}
          name="start_date"
          placeholder={t("O_START_DATE")}
          value={startDate}
          options={{
            maxDate: endDate,
            dateFormat: "m/d/Y",
            plugins: [yearDropdownPlugin({ startYear: 2020 })],
          }}
          onChange={onChangeStartDate}
        />

      </div>
      <div className="relative flex items-center mb-3">
        <label className="mx-2 text-[#B8BBBF] text-xs whitespace-nowrap">{t("O_TO")}</label>
        <Flatpickr
          className={pickerClasses.join(" ")}
          name="end_date"
          placeholder={t("O_END_DATE")}
          value={endDate}
          options={{
            minDate: startDate, 
            dateFormat: "m/d/Y",
            plugins: [yearDropdownPlugin({ startYear: 2020 })],
          }}
          onChange={onChangeEndDate}
        />
      </div>
    </>
    // </div>
  );
};

export default ODateRangePicker;
